import { createFileRoute, redirect } from '@tanstack/react-router';

import { redirectResearchersToDashboard } from '@/routes/participants/-utils/participant-route-guards';
import { ProjectDetail } from '@/routes/participants/_authenticated/projects/$projectId/-components/project-detail';
import {
  projectSearchSchema,
  prefetchProjectData,
} from '@/routes/participants/_authenticated/projects/$projectId/-shared';

export const Route = createFileRoute(
  '/participants/_public/projects/$projectId/{-$slug}',
)({
  validateSearch: projectSearchSchema,

  beforeLoad: async ({ params, search, context }) => {
    const { user, profile, env } = context;

    if (user) {
      redirectResearchersToDashboard(user, env);
    }

    const hasCompletedOnboarding = profile?.isOnboardingComplete;

    if (user && !user.isEmailVerified) {
      throw redirect({ to: '/participants/verify-email' });
    }

    if (user && !hasCompletedOnboarding) {
      throw redirect({ to: '/participants/onboarding' });
    }

    await prefetchProjectData(
      context.queryClient,
      params.projectId,
      search,
      context.user?.id,
    );
  },

  component: function ProjectDetailPageWrapper() {
    const { projectId } = Route.useParams();
    const search = Route.useSearch();
    return <ProjectDetail projectId={projectId} search={search} />;
  },
});
